export default __webpack_public_path__ + "static/dots-pattren-d169905803233011a90b4dd30f4ae791.svg";